import { useState, useEffect } from 'react'

import type { MouseEvent } from 'react'

const useSingleAndDoubleClick = (
  actionSimpleClick: (evt: MouseEvent) => void,
  actionDoubleClick: (evt: MouseEvent) => void,
  delay = 250
): ((evt: MouseEvent) => void) => {
  const [state, setState] = useState<{ click: number; e: MouseEvent | null }>({ click: 0, e: null })

  useEffect(() => {
    const timer = setTimeout(() => {
      // simple click
      if (state.click === 1) actionSimpleClick(state.e!)
      setState({ click: 0, e: state.e })
    }, delay)

    // the duration between this click and the previous one
    // is less than the value of delay = double-click
    if (state.click === 2) actionDoubleClick(state.e!)

    return () => clearTimeout(timer)
  }, [state, actionSimpleClick, actionDoubleClick, delay])

  return (e: MouseEvent) => setState({ click: state.click + 1, e })
}

export default useSingleAndDoubleClick
